import { Alert, Snackbar } from "@mui/material";
import React, { FC } from "react";
import { useAppDispatch, useAppSelector } from "../../redux";
import { hideFeedbackNotification } from "../../redux/reducers/notifications.reducer";

const FeedbackNotification: FC = () => {
	const dispatch = useAppDispatch();

	const notificationsState = useAppSelector((state) => state.notifications);

	function handleCloseFeedbackNotification() {
		dispatch(hideFeedbackNotification());
	}

	return (
		<Snackbar
			open={notificationsState.feedbackNotification.show}
			anchorOrigin={{ vertical: "top", horizontal: "right" }}
			// TransitionComponent={TransitionLeft}
			autoHideDuration={3000}
			onClose={handleCloseFeedbackNotification}
		>
			<Alert
				onClose={handleCloseFeedbackNotification}
				variant="filled"
				severity={notificationsState.feedbackNotification.severity}
				sx={{ width: "100%", whiteSpace: "pre-line" }}
				classes={{
					filledError: "notification-error",
					filledSuccess: "notification-success",
					filledWarning: "notification-warning",
					filledInfo: "notification-info"
				}}
			>
				{notificationsState.feedbackNotification.message}
			</Alert>
		</Snackbar>
	);
};

export default FeedbackNotification;
